import usePermittedQuery from '_api/queries/usePermittedQuery';
import { MessageCorrespondents } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';
// Get Correspondents
export const GET_MESSAGE_CORRESPONDENTS = 'get-message-correspondents';

export const useGetMessageCorrespondents = () =>
  usePermittedQuery<MessageCorrespondents[]>(
    [ACCOUNT_TYPE.THERAPIST],
    () => `/message/correspondents`,
    {},
    [GET_MESSAGE_CORRESPONDENTS],
    {
      refetchOnWindowFocus: false,
    },
  );
